/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SkirtInputs */

const en_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skirt`)
};

const es_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falda`)
};

const fr_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jupe`)
};

const de_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rock`)
};

const ja_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スカート`)
};

const zh_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`半身裙`)
};

const ar_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنورة`)
};

const id_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rok`)
};

const it_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gonna`)
};

const ru_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юбка`)
};

const pt_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saia`)
};

const ko_val_skirt = /** @type {(inputs: Val_SkirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스커트`)
};

/**
* | output |
* | --- |
* | "Skirt" |
*
* @param {Val_SkirtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_skirt = /** @type {((inputs?: Val_SkirtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SkirtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_skirt(inputs)
	if (locale === "es") return es_val_skirt(inputs)
	if (locale === "fr") return fr_val_skirt(inputs)
	if (locale === "de") return de_val_skirt(inputs)
	if (locale === "ja") return ja_val_skirt(inputs)
	if (locale === "zh") return zh_val_skirt(inputs)
	if (locale === "ar") return ar_val_skirt(inputs)
	if (locale === "id") return id_val_skirt(inputs)
	if (locale === "it") return it_val_skirt(inputs)
	if (locale === "ru") return ru_val_skirt(inputs)
	if (locale === "pt") return pt_val_skirt(inputs)
	return ko_val_skirt(inputs)
});